<template>
    <div class="keyword-for-time fs-14px w-100 bg-white">
        <div class="fs-18px mb-2 title-dialog mb-2 w-100 " style="color: rgb(255, 255, 255);">
            Cài đặt đấu giá từ khóa 
        </div>
        <div class="close-modal-mobile" @click="back"><i class="ionic ion-ios-arrow-back"></i></div>
        <div class="box-keyword w-100">
            <div class="tr d-flex">
                <div class="title fw-600  w-30">Từ khóa:</div>
                <div class="w-70 kw">{{ product.kep_keyword }}</div>
            </div>
            <div class="tr d-flex">
                <div class="title fw-600  w-30">Trạng thái:</div>
                <div :class="{
                        'w-70' : true,
                        't_w'  : product.status > 1,
                        't-s'  : product.status == 1,
                        't-c'  : product.status == null
                        }">
                    {{ product.status_text }}
                </div>
            </div>
            <div class="tr d-flex">
                <div class="title fw-600  w-30">Giá cao nhất:</div>
                <div class="w-70 price">{{ $formatNumber(price) }}₫</div>
            </div>
            <div class="tr d-flex">
                <div class="title fw-600 w-30">Giá đặt:</div>
                <div class="w-70">
                     <select v-model="product.price" class="text-center">
                        <option disabled value="" class="text-center">Chọn</option>
                        <option v-for="(item, key) in arrPrice" :key="key" :value="item" class="text-center">{{ $formatNumber(item) }}₫</option>
                    </select>
                </div>
            </div>
            <div class="tr d-flex">
                <div class="title fw-600 w-30">Thời gian bắt đầu:</div>
                <div class="w-70">
                    <td width="140" class="text-center keyword-sale">
                        <div :class="{'d-flex' : true, 'justify-content-between' : $detect == 'mobile', 'mb-1' : true}">
                            <div :class="{
                                    'fw-600' : true,
                                    'mr-1'   : true
                                }">
                              <input type="date" class="date-change" v-model="product.start_date"
                                   />
                            </div>
                            <div>
                                <ldc-time placeholder="HH:mm"
                                    :showSeconds="false"
                                    :jumpMinutes="5"
                                    titleMobile="Thời gian"
                                    v-model="product.start_time"
                                    class="time-change"/>
                            </div>
                        </div>
                    </td>
                </div>
            </div>
            <div class="tr d-flex">
                <div class="title fw-600 w-30">Thời gian kết thúc:</div>
                <div class="w-70">
                    <td width="140" class="text-center keyword-sale">
                        <div :class="{'d-flex' : true, 'justify-content-between' : $detect == 'mobile', 'mb-1' : true}">
                            <div :class="{
                                    'fw-600' : true,
                                    'mr-1'   : true
                                }">
                              <input type="date" class="date-change" v-model="product.end_date"
                                   />
                            </div>
                            <div>
                                <ldc-time placeholder="HH:mm"
                                    :showSeconds="false"
                                    :jumpMinutes="5"
                                    titleMobile="Thời gian"
                                    v-model="product.end_time"
                                    class="time-change"/>
                            </div>
                        </div>
                    </td>
                </div>
            </div>
            <div class="tr d-flex">
                <div class="title fw-600  w-30">Thiết lập tối đa:</div>
                <div class="w-70">
                    <input type="text" inputmode="numeric" class="input-price-up ml-1" v-model="product.max_amount"
                        @input="calculatePrice"/>
                </div>
            </div>
            <div class="tr d-flex">
                <div class="title fw-600  w-30">Đã tiêu:</div>
                <div class="w-70 price">{{ $formatNumber(product.spent) }}₫</div>
            </div>
            <div class="tr d-flex">
                <div class="title fw-600  w-30">Tự động gia hạn:</div>
                <div class="w-70">
                    <div class="custom-control custom-checkbox">
                        <input type="checkbox" id="allday" class="custom-control-input" v-model="product.auto_extend">
                        <label for="allday" class="custom-control-label"></label>
                    </div>
                </div>
            </div>
            <div class="tr d-flex">
                <div class="btn btn-primary done pl-5 pr-5" @click="back">Hoàn thành</div>
            </div>
        </div>
    </div>
</template>
<script>
import { getMinutes } from '@/config/function';
export default {
    props: ['data', 'arrPrice','show'],
    data() {
        return {
            product : [],
            price : 0,
        }
    },
    computed: {
       
    },
    watch: {
        data(val){
            this.product = val;
            this.product.max_amount = this.$formatNumber(this.product.max_amount);
 
        },
        product(val){
            this.$emit('update:data', val);
        }
    },
    created() {
        this.product = this.data;
        this.product.max_amount = this.$formatNumber(this.product.max_amount);
        this.price = this.product.price;
    },
    methods: {
       back(){
            this.$emit('update:show', false);
       },
       calculatePrice(){
            this.product.max_amount = this.$formatNumber(this.product.max_amount);
       }
    }
}
</script>
<style lang="scss">
.keyword-for-time{
    top: 0;
    height: 100%;
    position: fixed;
    z-index: 999;
    margin-left: -.5rem;
    .title-dialog{
        background: #0c81f6;
        padding: 10px;
        font-size: 16px !important;
        margin-bottom: 0 !important;
        text-align: center;
        box-shadow: 0 4px 25px 0 rgba(0, 0, 0, 0.1);
    }
    .close-modal-mobile{
        position: absolute;
        top: 0;
        left: 0;
        .ion-ios-arrow-back{
            color: #fff;
            font-size: 25px;
            line-height: 40px;
            padding: 0 18px;
        }
    }
    .box-keyword{
        .tr{
            padding: 10px;
            .w-30{
                width: 30%;
            }
            .w-70{
                width: 70%;
                &.kw{
                    color: #007bff;
                }
                &.price{
                    color: #dc3545;
                }
                &.t_w{
                    color : red;
                }
                &.t_s{
                    color : #28a745;
                }
                &.t_c{
                    color : #fd7e14;
                }
            }
        }
        .done{
            margin : 0 auto;
        }
        .input-price-up{
            border: none;
            border-bottom: 1px solid #000;
            width: 75px;
            border-radius: 0 !important;
            color: #dc3545;
            font-weight: 600;
        }
        select{
            height: 35px;
            border-radius: 4px;
            border: 1px solid rgba(0, 0, 0, 0.2);
            color: #606266;
            outline: none;
            cursor: pointer;
            width: 135px;
        }
    }
}

</style>
